import React, { useRef, useState } from 'react';

import { Container, SliderRelated, useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';
import { SearchResultsHeadless } from '@uncinc/react-searchkit';
import { useTranslation } from 'react-i18next';

import { SCREEN_TABLET, SCREEN_NORMAL } from '../../config/constants';

import PartnerSearchWrapper from '../PartnerSearch/Wrapper';
import PartnerItem from '../PartnerSearch/PartnerItem';

import './style.scss';

const SLIDER_THRESHOLD = 5;

const AnimatedPartners: React.FC = () => {
  const { t } = useTranslation();
  const sliderRef = useRef<any>(null);
  const [paused, setPaused] = useState(false);
  const [showSlider, setShowSlider] = useState(false);
  const { width } = useWindowDimensions();

  let slidesToShow = 5;
  let centerPadding = '10%';

  if (width < SCREEN_NORMAL) {
    slidesToShow = 3;
    centerPadding = '40px';
  }
  if (width < SCREEN_TABLET) {
    slidesToShow = 2;
    centerPadding = '8%';
  }

  const handleTogglePause = () => {
    if (paused) {
      sliderRef.current?.slickPlay();
    } else {
      sliderRef.current?.slickPause();
    }
    setPaused(!paused);
  };

  return (
    <div className="AnimatedPartners">
      <Container className="AnimatedPartners__inner">
        <h3>{t('components.animated_partners.title')}</h3>
        {showSlider && (
          <button
            className="AnimatedPartners__button Button Button--link"
            type="button"
            onClick={handleTogglePause}
          >
            {paused
              ? <span>{t('components.animated_partners.play')} <span>&#x23F5;</span></span>
              : <span>{t('components.animated_partners.pause')} <span>&#x23F8;</span></span>}
          </button>
        )}
        <PartnerSearchWrapper hitsPerPage={100}>
          <SearchResultsHeadless loadAllPages>
            {(hits: any[]) => {
              const hasEnoughHits = hits.length > SLIDER_THRESHOLD;

              if (hasEnoughHits !== showSlider) {
                setShowSlider(hasEnoughHits);
              }

              return hasEnoughHits
                ? (
                  <SliderRelated
                    slidesToShow={slidesToShow}
                    sliderRef={sliderRef}
                    centerMode
                    centerPadding={centerPadding}
                  >
                    {hits.map((hit) => <PartnerItem key={hit.url[0]} hit={hit} />)}
                  </SliderRelated>
                )
                : (
                  <ul className="AnimatedPartners__row">
                    {hits.map((hit) => <li><PartnerItem key={hit.url[0]} hit={hit} /></li>)}
                  </ul>
                );
            }}
          </SearchResultsHeadless>
        </PartnerSearchWrapper>
      </Container>
    </div>
  );
};

export default AnimatedPartners;
